module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPf394SEhACZ/wyX4hiGuQWJ3AGE1RF/uxV9tA59tw59vBN6tAx6uQp6tgt1sQh1rwluqgZnnwNnnzoAADEAAAgICCEAABkAABAAAAAAAP///wAAAAAAAAAAAAAAAAAAACH5BAEAABoALAAAAAAgACAAAAWBoCaOZGmeaKqubOu+cCzPcxDQq+1mfO//QOAIkLEZbRmKpTehXHpHoyYjKkat0ay2Or3ytNfs6HuEgo1YbTpgPrPX5evTjYSjrxi797xu8/VsXoBogGtLg0hucGSKYlWIdFEiFVVqZj0UZxqUJIJBfmg4Ojgno6SnqKmqq6ytrhohADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadE2_S7.gif
// module id = Up+X
// module chunks = 50